module.exports = {
  "alias": {
    "color": {
      "surface": {
        "default": "rgb(var(--tokens-alias-color-surface-default))",
        "hovered": "rgb(var(--tokens-alias-color-surface-hovered))",
        "disabled": "rgb(var(--tokens-alias-color-surface-disabled))",
        "transparent": {
          "default": "rgba(var(--tokens-alias-color-surface-transparent-default),var(--tokens-alias-color-surface-transparent-default-alpha))",
          "hovered": "rgba(var(--tokens-alias-color-surface-transparent-hovered),var(--tokens-alias-color-surface-transparent-hovered-alpha))",
          "lighter": "rgba(var(--tokens-alias-color-surface-transparent-lighter),var(--tokens-alias-color-surface-transparent-lighter-alpha))",
          "disabled": "rgba(var(--tokens-alias-color-surface-transparent-disabled),var(--tokens-alias-color-surface-transparent-disabled-alpha))"
        },
        "overlay": {
          "default": "rgba(var(--tokens-alias-color-surface-overlay-default),var(--tokens-alias-color-surface-overlay-default-alpha))",
          "hovered": "rgba(var(--tokens-alias-color-surface-overlay-hovered),var(--tokens-alias-color-surface-overlay-hovered-alpha))",
          "lighter": {
            "linearGradient": "linear-gradient(var(--tokens-alias-color-surface-overlay-lighter-linearGradient-alignment), rgba(var(--tokens-alias-color-surface-overlay-lighter-linearGradient-begin-color),var(--tokens-alias-color-surface-overlay-lighter-linearGradient-begin-color-alpha)) var(--tokens-alias-color-surface-overlay-lighter-linearGradient-begin-percentage), rgba(var(--tokens-alias-color-surface-overlay-lighter-linearGradient-end-color),var(--tokens-alias-color-surface-overlay-lighter-linearGradient-end-color-alpha)) var(--tokens-alias-color-surface-overlay-lighter-linearGradient-end-percentage))"
          }
        },
        "selected": {
          "default": "rgb(var(--tokens-alias-color-surface-selected-default))",
          "hovered": "rgb(var(--tokens-alias-color-surface-selected-hovered))",
          "highlight": "rgb(var(--tokens-alias-color-surface-selected-highlight))"
        },
        "interaction": {
          "primary": {
            "default": "rgb(var(--tokens-alias-color-surface-interaction-primary-default))",
            "hovered": "rgb(var(--tokens-alias-color-surface-interaction-primary-hovered))",
            "disabled": "rgb(var(--tokens-alias-color-surface-interaction-primary-disabled))"
          },
          "secondary": {
            "default": "rgb(var(--tokens-alias-color-surface-interaction-secondary-default))",
            "hovered": "rgb(var(--tokens-alias-color-surface-interaction-secondary-hovered))"
          },
          "inactive": {
            "default": "rgb(var(--tokens-alias-color-surface-interaction-inactive-default))",
            "hovered": "rgb(var(--tokens-alias-color-surface-interaction-inactive-hovered))"
          },
          "default": "rgb(var(--tokens-alias-color-surface-interaction-default))",
          "hovered": "rgb(var(--tokens-alias-color-surface-interaction-hovered))",
          "disabled": "rgb(var(--tokens-alias-color-surface-interaction-disabled))",
          "special": {
            "default": "rgb(var(--tokens-alias-color-surface-interaction-special-default))",
            "hovered": "rgb(var(--tokens-alias-color-surface-interaction-special-hovered))"
          }
        },
        "critical": {
          "default": "rgb(var(--tokens-alias-color-surface-critical-default))",
          "hovered": "rgb(var(--tokens-alias-color-surface-critical-hovered))",
          "lighter": {
            "default": "rgb(var(--tokens-alias-color-surface-critical-lighter-default))",
            "hovered": "rgb(var(--tokens-alias-color-surface-critical-lighter-hovered))"
          }
        },
        "warning": {
          "default": "rgb(var(--tokens-alias-color-surface-warning-default))",
          "lighter": "rgb(var(--tokens-alias-color-surface-warning-lighter))"
        },
        "positive": {
          "default": "rgb(var(--tokens-alias-color-surface-positive-default))",
          "lighter": {
            "default": "rgb(var(--tokens-alias-color-surface-positive-lighter-default))",
            "hovered": "rgb(var(--tokens-alias-color-surface-positive-lighter-hovered))"
          }
        },
        "highlight": {
          "default": "rgb(var(--tokens-alias-color-surface-highlight-default))",
          "hovered": "rgb(var(--tokens-alias-color-surface-highlight-hovered))"
        },
        "skeleton": {
          "linearGradient": "linear-gradient(var(--tokens-alias-color-surface-skeleton-linearGradient-alignment), rgb(var(--tokens-alias-color-surface-skeleton-linearGradient-begin-color)) , rgb(var(--tokens-alias-color-surface-skeleton-linearGradient-medium-color)) , rgb(var(--tokens-alias-color-surface-skeleton-linearGradient-end-color)) )",
          "inverse": {
            "linearGradient": "linear-gradient(var(--tokens-alias-color-surface-skeleton-inverse-linearGradient-alignment), rgb(var(--tokens-alias-color-surface-skeleton-inverse-linearGradient-begin-color)) , rgb(var(--tokens-alias-color-surface-skeleton-inverse-linearGradient-medium-color)) , rgb(var(--tokens-alias-color-surface-skeleton-inverse-linearGradient-end-color)) )"
          }
        },
        "notification": {
          "default": "rgb(var(--tokens-alias-color-surface-notification-default))"
        },
        "brand": {
          "highlight": "rgb(var(--tokens-alias-color-surface-brand-highlight))",
          "default": "rgb(var(--tokens-alias-color-surface-brand-default))",
          "hovered": "rgb(var(--tokens-alias-color-surface-brand-hovered))",
          "decorative": {
            "01": "rgb(var(--tokens-alias-color-surface-brand-decorative-01))",
            "02": "rgb(var(--tokens-alias-color-surface-brand-decorative-02))",
            "03": "rgb(var(--tokens-alias-color-surface-brand-decorative-03))",
            "04": "rgb(var(--tokens-alias-color-surface-brand-decorative-04))",
            "05": "rgb(var(--tokens-alias-color-surface-brand-decorative-05))",
            "06": "rgb(var(--tokens-alias-color-surface-brand-decorative-06))"
          }
        }
      },
      "text": {
        "default": "rgb(var(--tokens-alias-color-text-default))",
        "lighter": "rgb(var(--tokens-alias-color-text-lighter))",
        "disabled": "rgb(var(--tokens-alias-color-text-disabled))",
        "onDisabled": "rgb(var(--tokens-alias-color-text-onDisabled))",
        "onSelected": {
          "default": "rgb(var(--tokens-alias-color-text-onSelected-default))",
          "hovered": "rgb(var(--tokens-alias-color-text-onSelected-hovered))"
        },
        "interaction": {
          "primary": {
            "default": "rgb(var(--tokens-alias-color-text-interaction-primary-default))",
            "hovered": "rgb(var(--tokens-alias-color-text-interaction-primary-hovered))"
          },
          "secondary": {
            "default": "rgb(var(--tokens-alias-color-text-interaction-secondary-default))",
            "hovered": "rgb(var(--tokens-alias-color-text-interaction-secondary-hovered))"
          },
          "default": "rgb(var(--tokens-alias-color-text-interaction-default))",
          "hovered": "rgb(var(--tokens-alias-color-text-interaction-hovered))",
          "special": {
            "default": "rgb(var(--tokens-alias-color-text-interaction-special-default))",
            "hovered": "rgb(var(--tokens-alias-color-text-interaction-special-hovered))"
          }
        },
        "inverse": {
          "default": "rgb(var(--tokens-alias-color-text-inverse-default))",
          "lighter": "rgba(var(--tokens-alias-color-text-inverse-lighter),var(--tokens-alias-color-text-inverse-lighter-alpha))",
          "disabled": "rgba(var(--tokens-alias-color-text-inverse-disabled),var(--tokens-alias-color-text-inverse-disabled-alpha))",
          "onDisabled": "rgba(var(--tokens-alias-color-text-inverse-onDisabled),var(--tokens-alias-color-text-inverse-onDisabled-alpha))"
        },
        "critical": {
          "default": "rgb(var(--tokens-alias-color-text-critical-default))",
          "hovered": "rgb(var(--tokens-alias-color-text-critical-hovered))"
        },
        "warning": "rgb(var(--tokens-alias-color-text-warning))",
        "positive": "rgb(var(--tokens-alias-color-text-positive))",
        "decorative": {
          "01": "rgb(var(--tokens-alias-color-text-decorative-01))"
        },
        "brand": {
          "default": "rgb(var(--tokens-alias-color-text-brand-default))",
          "inverse": "rgb(var(--tokens-alias-color-text-brand-inverse))"
        }
      },
      "icon": {
        "default": "rgb(var(--tokens-alias-color-icon-default))",
        "lighter": "rgb(var(--tokens-alias-color-icon-lighter))",
        "disabled": "rgb(var(--tokens-alias-color-icon-disabled))",
        "onDisabled": "rgb(var(--tokens-alias-color-icon-onDisabled))",
        "inverse": {
          "default": "rgb(var(--tokens-alias-color-icon-inverse-default))",
          "lighter": "rgba(var(--tokens-alias-color-icon-inverse-lighter),var(--tokens-alias-color-icon-inverse-lighter-alpha))",
          "disabled": "rgba(var(--tokens-alias-color-icon-inverse-disabled),var(--tokens-alias-color-icon-inverse-disabled-alpha))"
        },
        "critical": {
          "default": "rgb(var(--tokens-alias-color-icon-critical-default))",
          "hovered": "rgb(var(--tokens-alias-color-icon-critical-hovered))"
        },
        "warning": "rgb(var(--tokens-alias-color-icon-warning))",
        "positive": "rgb(var(--tokens-alias-color-icon-positive))",
        "decorative": {
          "16": "rgb(var(--tokens-alias-color-icon-decorative-16))",
          "23": "rgb(var(--tokens-alias-color-icon-decorative-23))",
          "28": "rgb(var(--tokens-alias-color-icon-decorative-28))",
          "31": "rgb(var(--tokens-alias-color-icon-decorative-31))",
          "01": "rgb(var(--tokens-alias-color-icon-decorative-01))",
          "08": "rgb(var(--tokens-alias-color-icon-decorative-08))"
        },
        "onSelected": {
          "default": "rgb(var(--tokens-alias-color-icon-onSelected-default))",
          "hovered": "rgb(var(--tokens-alias-color-icon-onSelected-hovered))"
        },
        "interaction": {
          "primary": {
            "default": "rgb(var(--tokens-alias-color-icon-interaction-primary-default))",
            "hovered": "rgb(var(--tokens-alias-color-icon-interaction-primary-hovered))"
          },
          "secondary": {
            "default": "rgb(var(--tokens-alias-color-icon-interaction-secondary-default))",
            "hovered": "rgb(var(--tokens-alias-color-icon-interaction-secondary-hovered))"
          },
          "default": "rgb(var(--tokens-alias-color-icon-interaction-default))",
          "hovered": "rgb(var(--tokens-alias-color-icon-interaction-hovered))",
          "special": {
            "default": "rgb(var(--tokens-alias-color-icon-interaction-special-default))",
            "hovered": "rgb(var(--tokens-alias-color-icon-interaction-special-hovered))"
          }
        },
        "brand": {
          "default": "rgb(var(--tokens-alias-color-icon-brand-default))",
          "inverse": "rgb(var(--tokens-alias-color-icon-brand-inverse))",
          "decorative": {
            "01": "rgb(var(--tokens-alias-color-icon-brand-decorative-01))",
            "02": "rgb(var(--tokens-alias-color-icon-brand-decorative-02))",
            "03": "rgb(var(--tokens-alias-color-icon-brand-decorative-03))",
            "04": "rgb(var(--tokens-alias-color-icon-brand-decorative-04))",
            "05": "rgb(var(--tokens-alias-color-icon-brand-decorative-05))",
            "06": "rgb(var(--tokens-alias-color-icon-brand-decorative-06))"
          }
        }
      },
      "border": {
        "default": "rgb(var(--tokens-alias-color-border-default))",
        "hovered": "rgb(var(--tokens-alias-color-border-hovered))",
        "disabled": "rgb(var(--tokens-alias-color-border-disabled))",
        "inverse": {
          "lighter": "rgba(var(--tokens-alias-color-border-inverse-lighter),var(--tokens-alias-color-border-inverse-lighter-alpha))",
          "default": "rgb(var(--tokens-alias-color-border-inverse-default))",
          "disabled": "rgba(var(--tokens-alias-color-border-inverse-disabled),var(--tokens-alias-color-border-inverse-disabled-alpha))"
        },
        "selected": {
          "default": "rgb(var(--tokens-alias-color-border-selected-default))",
          "hovered": "rgb(var(--tokens-alias-color-border-selected-hovered))"
        },
        "interaction": {
          "primary": {
            "default": "rgb(var(--tokens-alias-color-border-interaction-primary-default))",
            "hovered": "rgb(var(--tokens-alias-color-border-interaction-primary-hovered))",
            "lighter": "rgb(var(--tokens-alias-color-border-interaction-primary-lighter))"
          },
          "secondary": {
            "default": "rgb(var(--tokens-alias-color-border-interaction-secondary-default))",
            "hovered": "rgb(var(--tokens-alias-color-border-interaction-secondary-hovered))"
          },
          "default": "rgb(var(--tokens-alias-color-border-interaction-default))",
          "hovered": "rgb(var(--tokens-alias-color-border-interaction-hovered))",
          "lighter": "rgb(var(--tokens-alias-color-border-interaction-lighter))"
        },
        "critical": "rgb(var(--tokens-alias-color-border-critical))",
        "warning": "rgb(var(--tokens-alias-color-border-warning))",
        "positive": "rgb(var(--tokens-alias-color-border-positive))",
        "highlight": "rgb(var(--tokens-alias-color-border-highlight))",
        "focusVisible": "rgb(var(--tokens-alias-color-border-focusVisible))"
      }
    },
    "elevation": {
      "low": {
        "shadow": "\n      var(--tokens-alias-elevation-low-shadow-direct-xOffset) var(--tokens-alias-elevation-low-shadow-direct-yOffset) var(--tokens-alias-elevation-low-shadow-direct-blur) var(--tokens-alias-elevation-low-shadow-direct-spread) rgba(var(--tokens-alias-elevation-low-shadow-direct-color),var(--tokens-alias-elevation-low-shadow-direct-color-alpha)),\n      var(--tokens-alias-elevation-low-shadow-difuse-xOffset) var(--tokens-alias-elevation-low-shadow-difuse-yOffset) var(--tokens-alias-elevation-low-shadow-difuse-blur) var(--tokens-alias-elevation-low-shadow-difuse-spread) rgba(var(--tokens-alias-elevation-low-shadow-difuse-color),var(--tokens-alias-elevation-low-shadow-difuse-color-alpha))\n    "
      },
      "medium": {
        "shadow": "\n      var(--tokens-alias-elevation-medium-shadow-direct-xOffset) var(--tokens-alias-elevation-medium-shadow-direct-yOffset) var(--tokens-alias-elevation-medium-shadow-direct-blur) var(--tokens-alias-elevation-medium-shadow-direct-spread) rgba(var(--tokens-alias-elevation-medium-shadow-direct-color),var(--tokens-alias-elevation-medium-shadow-direct-color-alpha)),\n      var(--tokens-alias-elevation-medium-shadow-difuse-xOffset) var(--tokens-alias-elevation-medium-shadow-difuse-yOffset) var(--tokens-alias-elevation-medium-shadow-difuse-blur) var(--tokens-alias-elevation-medium-shadow-difuse-spread) rgba(var(--tokens-alias-elevation-medium-shadow-difuse-color),var(--tokens-alias-elevation-medium-shadow-difuse-color-alpha))\n    "
      },
      "high": {
        "shadow": "\n      var(--tokens-alias-elevation-high-shadow-direct-xOffset) var(--tokens-alias-elevation-high-shadow-direct-yOffset) var(--tokens-alias-elevation-high-shadow-direct-blur) var(--tokens-alias-elevation-high-shadow-direct-spread) rgba(var(--tokens-alias-elevation-high-shadow-direct-color),var(--tokens-alias-elevation-high-shadow-direct-color-alpha)),\n      var(--tokens-alias-elevation-high-shadow-difuse-xOffset) var(--tokens-alias-elevation-high-shadow-difuse-yOffset) var(--tokens-alias-elevation-high-shadow-difuse-blur) var(--tokens-alias-elevation-high-shadow-difuse-spread) rgba(var(--tokens-alias-elevation-high-shadow-difuse-color),var(--tokens-alias-elevation-high-shadow-difuse-color-alpha))\n    "
      }
    },
    "shape": {
      "border": {
        "radius": {
          "sharp": "var(--tokens-alias-shape-border-radius-sharp)",
          "xsmall": "var(--tokens-alias-shape-border-radius-xsmall)",
          "small": "var(--tokens-alias-shape-border-radius-small)",
          "medium": "var(--tokens-alias-shape-border-radius-medium)",
          "rounded": "var(--tokens-alias-shape-border-radius-rounded)",
          "pill": "var(--tokens-alias-shape-border-radius-pill)"
        }
      }
    },
    "spacing": {
      "hxxsmall": "var(--tokens-alias-spacing-hxxsmall)",
      "xxsmall": "var(--tokens-alias-spacing-xxsmall)",
      "xsmall": "var(--tokens-alias-spacing-xsmall)",
      "hsmall": "var(--tokens-alias-spacing-hsmall)",
      "hlarge": "var(--tokens-alias-spacing-hlarge)",
      "small": "var(--tokens-alias-spacing-small)",
      "medium": "var(--tokens-alias-spacing-medium)",
      "large": "var(--tokens-alias-spacing-large)",
      "xlarge": "var(--tokens-alias-spacing-xlarge)",
      "xxlarge": "var(--tokens-alias-spacing-xxlarge)",
      "xxxlarge": "var(--tokens-alias-spacing-xxxlarge)",
      "huge": "var(--tokens-alias-spacing-huge)",
      "xhuge": "var(--tokens-alias-spacing-xhuge)",
      "xxhuge": "var(--tokens-alias-spacing-xxhuge)",
      "xxxhuge": "var(--tokens-alias-spacing-xxxhuge)"
    },
    "typography": {
      "fontFamily": "var(--tokens-alias-typography-fontFamily)",
      "fontSizeBase": "var(--tokens-alias-typography-fontSizeBase)",
      "fontFeatureSettings": "var(--tokens-alias-typography-fontFeatureSettings)",
      "selection": "rgba(var(--tokens-alias-typography-selection),var(--tokens-alias-typography-selection-alpha))",
      "heroLarge": {
        "fontSize": "var(--tokens-alias-typography-heroLarge-fontSize)",
        "fontWeight": "var(--tokens-alias-typography-heroLarge-fontWeight)",
        "lineHeight": "var(--tokens-alias-typography-heroLarge-lineHeight)",
        "letterSpacing": "var(--tokens-alias-typography-heroLarge-letterSpacing)"
      },
      "heroMedium": {
        "fontSize": "var(--tokens-alias-typography-heroMedium-fontSize)",
        "fontWeight": "var(--tokens-alias-typography-heroMedium-fontWeight)",
        "lineHeight": "var(--tokens-alias-typography-heroMedium-lineHeight)",
        "letterSpacing": "var(--tokens-alias-typography-heroMedium-letterSpacing)"
      },
      "heroSmall": {
        "fontSize": "var(--tokens-alias-typography-heroSmall-fontSize)",
        "fontWeight": "var(--tokens-alias-typography-heroSmall-fontWeight)",
        "lineHeight": "var(--tokens-alias-typography-heroSmall-lineHeight)",
        "letterSpacing": "var(--tokens-alias-typography-heroSmall-letterSpacing)"
      },
      "display": {
        "fontSize": "var(--tokens-alias-typography-display-fontSize)",
        "fontWeight": "var(--tokens-alias-typography-display-fontWeight)",
        "lineHeight": "var(--tokens-alias-typography-display-lineHeight)",
        "letterSpacing": "var(--tokens-alias-typography-display-letterSpacing)"
      },
      "heading": {
        "fontSize": "var(--tokens-alias-typography-heading-fontSize)",
        "fontWeight": "var(--tokens-alias-typography-heading-fontWeight)",
        "lineHeight": "var(--tokens-alias-typography-heading-lineHeight)",
        "letterSpacing": "var(--tokens-alias-typography-heading-letterSpacing)"
      },
      "title": {
        "fontSize": "var(--tokens-alias-typography-title-fontSize)",
        "fontWeight": "var(--tokens-alias-typography-title-fontWeight)",
        "lineHeight": "var(--tokens-alias-typography-title-lineHeight)",
        "letterSpacing": "var(--tokens-alias-typography-title-letterSpacing)"
      },
      "bodyStrong": {
        "fontSize": "var(--tokens-alias-typography-bodyStrong-fontSize)",
        "fontWeight": "var(--tokens-alias-typography-bodyStrong-fontWeight)",
        "lineHeight": "var(--tokens-alias-typography-bodyStrong-lineHeight)"
      },
      "body": {
        "fontSize": "var(--tokens-alias-typography-body-fontSize)",
        "fontWeight": "var(--tokens-alias-typography-body-fontWeight)",
        "lineHeight": "var(--tokens-alias-typography-body-lineHeight)"
      },
      "captionStrong": {
        "fontSize": "var(--tokens-alias-typography-captionStrong-fontSize)",
        "fontWeight": "var(--tokens-alias-typography-captionStrong-fontWeight)",
        "lineHeight": "var(--tokens-alias-typography-captionStrong-lineHeight)"
      },
      "caption": {
        "fontSize": "var(--tokens-alias-typography-caption-fontSize)",
        "fontWeight": "var(--tokens-alias-typography-caption-fontWeight)",
        "lineHeight": "var(--tokens-alias-typography-caption-lineHeight)"
      }
    },
    "zIndex": {
      "low": "-1",
      "default": "0",
      "high": "1",
      "higher": "2",
      "sticky": "1000",
      "appBar": "1100",
      "actionBar": "1100",
      "drawer": "1200",
      "modal": "1300",
      "snackbar": "1400",
      "tooltip": "1500"
    }
  },
  "component": {
    "accordion": {
      "shape": {
        "border": {
          "radius": {
            "default": "var(--tokens-component-accordion-shape-border-radius-default)"
          }
        }
      }
    },
    "alert": {
      "shape": {
        "border": {
          "radius": {
            "default": "var(--tokens-component-alert-shape-border-radius-default)"
          }
        }
      }
    },
    "button": {
      "color": {
        "special": {
          "default": {
            "background": "rgb(var(--tokens-component-button-color-special-default-background))",
            "text": "rgb(var(--tokens-component-button-color-special-default-text))",
            "spinner": {
              "indicator": {
                "stroke": "rgb(var(--tokens-component-button-color-special-default-spinner-indicator-stroke))"
              },
              "base": {
                "stroke": "rgba(var(--tokens-component-button-color-special-default-spinner-base-stroke),var(--tokens-component-button-color-special-default-spinner-base-stroke-alpha))"
              }
            }
          },
          "hovered": {
            "background": "rgb(var(--tokens-component-button-color-special-hovered-background))"
          },
          "active": {
            "background": "rgb(var(--tokens-component-button-color-special-active-background))"
          },
          "disabled": {
            "background": "rgb(var(--tokens-component-button-color-special-disabled-background))",
            "text": "rgb(var(--tokens-component-button-color-special-disabled-text))"
          }
        },
        "default": {
          "default": {
            "background": "rgb(var(--tokens-component-button-color-default-default-background))",
            "text": "rgb(var(--tokens-component-button-color-default-default-text))",
            "spinner": {
              "indicator": {
                "stroke": "rgb(var(--tokens-component-button-color-default-default-spinner-indicator-stroke))"
              },
              "base": {
                "stroke": "rgba(var(--tokens-component-button-color-default-default-spinner-base-stroke),var(--tokens-component-button-color-default-default-spinner-base-stroke-alpha))"
              }
            }
          },
          "hovered": {
            "background": "rgb(var(--tokens-component-button-color-default-hovered-background))",
            "text": "rgb(var(--tokens-component-button-color-default-hovered-text))"
          },
          "active": {
            "background": "rgb(var(--tokens-component-button-color-default-active-background))"
          },
          "disabled": {
            "background": "rgb(var(--tokens-component-button-color-default-disabled-background))",
            "text": "rgb(var(--tokens-component-button-color-default-disabled-text))"
          }
        },
        "defaultInverse": {
          "default": {
            "background": "rgb(var(--tokens-component-button-color-defaultInverse-default-background))",
            "text": "rgb(var(--tokens-component-button-color-defaultInverse-default-text))",
            "spinner": {
              "indicator": {
                "stroke": "rgb(var(--tokens-component-button-color-defaultInverse-default-spinner-indicator-stroke))"
              },
              "base": {
                "stroke": "rgba(var(--tokens-component-button-color-defaultInverse-default-spinner-base-stroke),var(--tokens-component-button-color-defaultInverse-default-spinner-base-stroke-alpha))"
              }
            }
          },
          "hovered": {
            "background": "rgb(var(--tokens-component-button-color-defaultInverse-hovered-background))",
            "text": "rgb(var(--tokens-component-button-color-defaultInverse-hovered-text))"
          },
          "active": {
            "background": "rgb(var(--tokens-component-button-color-defaultInverse-active-background))",
            "text": "rgb(var(--tokens-component-button-color-defaultInverse-active-text))"
          },
          "disabled": {
            "background": "rgba(var(--tokens-component-button-color-defaultInverse-disabled-background),var(--tokens-component-button-color-defaultInverse-disabled-background-alpha))",
            "text": "rgba(var(--tokens-component-button-color-defaultInverse-disabled-text),var(--tokens-component-button-color-defaultInverse-disabled-text-alpha))"
          }
        },
        "destructive": {
          "default": {
            "background": "rgb(var(--tokens-component-button-color-destructive-default-background))",
            "text": "rgb(var(--tokens-component-button-color-destructive-default-text))",
            "spinner": {
              "indicator": {
                "stroke": "rgb(var(--tokens-component-button-color-destructive-default-spinner-indicator-stroke))"
              },
              "base": {
                "stroke": "rgba(var(--tokens-component-button-color-destructive-default-spinner-base-stroke),var(--tokens-component-button-color-destructive-default-spinner-base-stroke-alpha))"
              }
            }
          },
          "hovered": {
            "background": "rgb(var(--tokens-component-button-color-destructive-hovered-background))"
          },
          "active": {
            "background": "rgb(var(--tokens-component-button-color-destructive-active-background))"
          },
          "disabled": {
            "background": "rgb(var(--tokens-component-button-color-destructive-disabled-background))",
            "text": "rgb(var(--tokens-component-button-color-destructive-disabled-text))"
          }
        },
        "quiet": {
          "default": {
            "background": "rgba(var(--tokens-component-button-color-quiet-default-background),var(--tokens-component-button-color-quiet-default-background-alpha))",
            "text": "rgb(var(--tokens-component-button-color-quiet-default-text))",
            "border": "rgba(var(--tokens-component-button-color-quiet-default-border),var(--tokens-component-button-color-quiet-default-border-alpha))",
            "spinner": {
              "indicator": {
                "stroke": "rgb(var(--tokens-component-button-color-quiet-default-spinner-indicator-stroke))"
              },
              "base": {
                "stroke": "rgba(var(--tokens-component-button-color-quiet-default-spinner-base-stroke),var(--tokens-component-button-color-quiet-default-spinner-base-stroke-alpha))"
              }
            }
          },
          "hovered": {
            "background": "rgb(var(--tokens-component-button-color-quiet-hovered-background))",
            "text": "rgb(var(--tokens-component-button-color-quiet-hovered-text))",
            "border": "rgba(var(--tokens-component-button-color-quiet-hovered-border),var(--tokens-component-button-color-quiet-hovered-border-alpha))"
          },
          "active": {
            "background": "rgb(var(--tokens-component-button-color-quiet-active-background))",
            "text": "rgb(var(--tokens-component-button-color-quiet-active-text))",
            "border": "rgba(var(--tokens-component-button-color-quiet-active-border),var(--tokens-component-button-color-quiet-active-border-alpha))"
          },
          "disabled": {
            "background": "rgba(var(--tokens-component-button-color-quiet-disabled-background),var(--tokens-component-button-color-quiet-disabled-background-alpha))",
            "text": "rgb(var(--tokens-component-button-color-quiet-disabled-text))",
            "border": "rgba(var(--tokens-component-button-color-quiet-disabled-border),var(--tokens-component-button-color-quiet-disabled-border-alpha))"
          }
        },
        "quietDestructive": {
          "default": {
            "background": "rgba(var(--tokens-component-button-color-quietDestructive-default-background),var(--tokens-component-button-color-quietDestructive-default-background-alpha))",
            "text": "rgb(var(--tokens-component-button-color-quietDestructive-default-text))",
            "border": "rgba(var(--tokens-component-button-color-quietDestructive-default-border),var(--tokens-component-button-color-quietDestructive-default-border-alpha))",
            "spinner": {
              "indicator": {
                "stroke": "rgb(var(--tokens-component-button-color-quietDestructive-default-spinner-indicator-stroke))"
              },
              "base": {
                "stroke": "rgba(var(--tokens-component-button-color-quietDestructive-default-spinner-base-stroke),var(--tokens-component-button-color-quietDestructive-default-spinner-base-stroke-alpha))"
              }
            }
          },
          "hovered": {
            "background": "rgb(var(--tokens-component-button-color-quietDestructive-hovered-background))",
            "text": "rgb(var(--tokens-component-button-color-quietDestructive-hovered-text))",
            "border": "rgba(var(--tokens-component-button-color-quietDestructive-hovered-border),var(--tokens-component-button-color-quietDestructive-hovered-border-alpha))"
          },
          "active": {
            "background": "rgb(var(--tokens-component-button-color-quietDestructive-active-background))",
            "text": "rgb(var(--tokens-component-button-color-quietDestructive-active-text))",
            "border": "rgba(var(--tokens-component-button-color-quietDestructive-active-border),var(--tokens-component-button-color-quietDestructive-active-border-alpha))"
          },
          "disabled": {
            "background": "rgba(var(--tokens-component-button-color-quietDestructive-disabled-background),var(--tokens-component-button-color-quietDestructive-disabled-background-alpha))",
            "text": "rgb(var(--tokens-component-button-color-quietDestructive-disabled-text))",
            "border": "rgba(var(--tokens-component-button-color-quietDestructive-disabled-border),var(--tokens-component-button-color-quietDestructive-disabled-border-alpha))"
          }
        },
        "quietInverse": {
          "default": {
            "background": "rgba(var(--tokens-component-button-color-quietInverse-default-background),var(--tokens-component-button-color-quietInverse-default-background-alpha))",
            "text": "rgb(var(--tokens-component-button-color-quietInverse-default-text))",
            "border": "rgba(var(--tokens-component-button-color-quietInverse-default-border),var(--tokens-component-button-color-quietInverse-default-border-alpha))",
            "spinner": {
              "indicator": {
                "stroke": "rgb(var(--tokens-component-button-color-quietInverse-default-spinner-indicator-stroke))"
              },
              "base": {
                "stroke": "rgba(var(--tokens-component-button-color-quietInverse-default-spinner-base-stroke),var(--tokens-component-button-color-quietInverse-default-spinner-base-stroke-alpha))"
              }
            }
          },
          "hovered": {
            "background": "rgba(var(--tokens-component-button-color-quietInverse-hovered-background),var(--tokens-component-button-color-quietInverse-hovered-background-alpha))",
            "text": "rgb(var(--tokens-component-button-color-quietInverse-hovered-text))",
            "border": "rgba(var(--tokens-component-button-color-quietInverse-hovered-border),var(--tokens-component-button-color-quietInverse-hovered-border-alpha))"
          },
          "active": {
            "background": "rgba(var(--tokens-component-button-color-quietInverse-active-background),var(--tokens-component-button-color-quietInverse-active-background-alpha))",
            "text": "rgb(var(--tokens-component-button-color-quietInverse-active-text))"
          },
          "disabled": {
            "background": "rgba(var(--tokens-component-button-color-quietInverse-disabled-background),var(--tokens-component-button-color-quietInverse-disabled-background-alpha))",
            "text": "rgba(var(--tokens-component-button-color-quietInverse-disabled-text),var(--tokens-component-button-color-quietInverse-disabled-text-alpha))"
          }
        },
        "paddingless": {
          "default": {
            "background": "rgba(var(--tokens-component-button-color-paddingless-default-background),var(--tokens-component-button-color-paddingless-default-background-alpha))",
            "text": "rgb(var(--tokens-component-button-color-paddingless-default-text))",
            "spinner": {
              "indicator": {
                "stroke": "rgb(var(--tokens-component-button-color-paddingless-default-spinner-indicator-stroke))"
              },
              "base": {
                "stroke": "rgba(var(--tokens-component-button-color-paddingless-default-spinner-base-stroke),var(--tokens-component-button-color-paddingless-default-spinner-base-stroke-alpha))"
              }
            }
          },
          "hovered": {
            "background": "rgba(var(--tokens-component-button-color-paddingless-hovered-background),var(--tokens-component-button-color-paddingless-hovered-background-alpha))",
            "text": "rgb(var(--tokens-component-button-color-paddingless-hovered-text))"
          },
          "active": {
            "background": "rgba(var(--tokens-component-button-color-paddingless-active-background),var(--tokens-component-button-color-paddingless-active-background-alpha))",
            "text": "rgb(var(--tokens-component-button-color-paddingless-active-text))"
          },
          "disabled": {
            "background": "rgba(var(--tokens-component-button-color-paddingless-disabled-background),var(--tokens-component-button-color-paddingless-disabled-background-alpha))",
            "text": "rgb(var(--tokens-component-button-color-paddingless-disabled-text))"
          }
        },
        "destructivePaddingless": {
          "default": {
            "background": "rgba(var(--tokens-component-button-color-destructivePaddingless-default-background),var(--tokens-component-button-color-destructivePaddingless-default-background-alpha))",
            "text": "rgb(var(--tokens-component-button-color-destructivePaddingless-default-text))",
            "spinner": {
              "indicator": {
                "stroke": "rgb(var(--tokens-component-button-color-destructivePaddingless-default-spinner-indicator-stroke))"
              },
              "base": {
                "stroke": "rgba(var(--tokens-component-button-color-destructivePaddingless-default-spinner-base-stroke),var(--tokens-component-button-color-destructivePaddingless-default-spinner-base-stroke-alpha))"
              }
            }
          },
          "hovered": {
            "background": "rgba(var(--tokens-component-button-color-destructivePaddingless-hovered-background),var(--tokens-component-button-color-destructivePaddingless-hovered-background-alpha))",
            "text": "rgb(var(--tokens-component-button-color-destructivePaddingless-hovered-text))"
          },
          "active": {
            "background": "rgba(var(--tokens-component-button-color-destructivePaddingless-active-background),var(--tokens-component-button-color-destructivePaddingless-active-background-alpha))",
            "text": "rgb(var(--tokens-component-button-color-destructivePaddingless-active-text))"
          },
          "disabled": {
            "background": "rgba(var(--tokens-component-button-color-destructivePaddingless-disabled-background),var(--tokens-component-button-color-destructivePaddingless-disabled-background-alpha))",
            "text": "rgb(var(--tokens-component-button-color-destructivePaddingless-disabled-text))"
          }
        },
        "paddinglessDestructive": {
          "default": {
            "background": "rgba(var(--tokens-component-button-color-paddinglessDestructive-default-background),var(--tokens-component-button-color-paddinglessDestructive-default-background-alpha))",
            "text": "rgb(var(--tokens-component-button-color-paddinglessDestructive-default-text))",
            "spinner": {
              "indicator": {
                "stroke": "rgb(var(--tokens-component-button-color-paddinglessDestructive-default-spinner-indicator-stroke))"
              },
              "base": {
                "stroke": "rgba(var(--tokens-component-button-color-paddinglessDestructive-default-spinner-base-stroke),var(--tokens-component-button-color-paddinglessDestructive-default-spinner-base-stroke-alpha))"
              }
            }
          },
          "hovered": {
            "background": "rgba(var(--tokens-component-button-color-paddinglessDestructive-hovered-background),var(--tokens-component-button-color-paddinglessDestructive-hovered-background-alpha))",
            "text": "rgb(var(--tokens-component-button-color-paddinglessDestructive-hovered-text))"
          },
          "active": {
            "background": "rgba(var(--tokens-component-button-color-paddinglessDestructive-active-background),var(--tokens-component-button-color-paddinglessDestructive-active-background-alpha))",
            "text": "rgb(var(--tokens-component-button-color-paddinglessDestructive-active-text))"
          },
          "disabled": {
            "background": "rgba(var(--tokens-component-button-color-paddinglessDestructive-disabled-background),var(--tokens-component-button-color-paddinglessDestructive-disabled-background-alpha))",
            "text": "rgb(var(--tokens-component-button-color-paddinglessDestructive-disabled-text))"
          }
        },
        "paddinglessInverse": {
          "default": {
            "background": "var(--tokens-component-button-color-paddinglessInverse-default-background)",
            "text": "rgb(var(--tokens-component-button-color-paddinglessInverse-default-text))",
            "spinner": {
              "indicator": {
                "stroke": "rgb(var(--tokens-component-button-color-paddinglessInverse-default-spinner-indicator-stroke))"
              },
              "base": {
                "stroke": "rgba(var(--tokens-component-button-color-paddinglessInverse-default-spinner-base-stroke),var(--tokens-component-button-color-paddinglessInverse-default-spinner-base-stroke-alpha))"
              }
            }
          },
          "disabled": {
            "background": "rgba(var(--tokens-component-button-color-paddinglessInverse-disabled-background),var(--tokens-component-button-color-paddinglessInverse-disabled-background-alpha))",
            "text": "var(--tokens-component-button-color-paddinglessInverse-disabled-text)"
          }
        }
      },
      "shape": {
        "border": {
          "radius": {
            "default": "var(--tokens-component-button-shape-border-radius-default)"
          }
        }
      },
      "spacing": {
        "default": {
          "padding": {
            "x": "var(--tokens-component-button-spacing-default-padding-x)",
            "y": "var(--tokens-component-button-spacing-default-padding-y)"
          }
        },
        "paddingless": {
          "padding": {
            "x": "var(--tokens-component-button-spacing-paddingless-padding-x)",
            "y": "var(--tokens-component-button-spacing-paddingless-padding-y)"
          }
        },
        "destructivePaddingless": {
          "padding": {
            "x": "var(--tokens-component-button-spacing-destructivePaddingless-padding-x)",
            "y": "var(--tokens-component-button-spacing-destructivePaddingless-padding-y)"
          }
        },
        "paddinglessDestructive": {
          "padding": {
            "x": "var(--tokens-component-button-spacing-paddinglessDestructive-padding-x)",
            "y": "var(--tokens-component-button-spacing-paddinglessDestructive-padding-y)"
          }
        },
        "paddinglessInverse": {
          "padding": {
            "x": "var(--tokens-component-button-spacing-paddinglessInverse-padding-x)",
            "y": "var(--tokens-component-button-spacing-paddinglessInverse-padding-y)"
          }
        }
      }
    },
    "card": {
      "shape": {
        "border": {
          "radius": {
            "default": "var(--tokens-component-card-shape-border-radius-default)"
          }
        }
      }
    },
    "cardChoice": {
      "shape": {
        "border": {
          "radius": {
            "default": "var(--tokens-component-cardChoice-shape-border-radius-default)"
          }
        },
        "horizontal": {
          "border": {
            "radius": {
              "default": "var(--tokens-component-cardChoice-shape-horizontal-border-radius-default)"
            }
          }
        },
        "vertical": {
          "border": {
            "radius": {
              "default": "var(--tokens-component-cardChoice-shape-vertical-border-radius-default)"
            }
          }
        }
      }
    },
    "cardMedia": {
      "shape": {
        "border": {
          "radius": {
            "default": "var(--tokens-component-cardMedia-shape-border-radius-default)"
          }
        }
      }
    },
    "checkbox": {
      "color": {
        "checked": {
          "default": {
            "background": "rgb(var(--tokens-component-checkbox-color-checked-default-background))",
            "border": "rgb(var(--tokens-component-checkbox-color-checked-default-border))",
            "icon": "rgb(var(--tokens-component-checkbox-color-checked-default-icon))",
            "label": "rgb(var(--tokens-component-checkbox-color-checked-default-label))"
          },
          "hovered": {
            "background": "rgb(var(--tokens-component-checkbox-color-checked-hovered-background))"
          },
          "disabled": {
            "background": "rgb(var(--tokens-component-checkbox-color-checked-disabled-background))",
            "border": "rgb(var(--tokens-component-checkbox-color-checked-disabled-border))",
            "icon": "rgb(var(--tokens-component-checkbox-color-checked-disabled-icon))",
            "label": "rgb(var(--tokens-component-checkbox-color-checked-disabled-label))"
          }
        },
        "unchecked": {
          "default": {
            "background": "rgb(var(--tokens-component-checkbox-color-unchecked-default-background))",
            "border": "rgb(var(--tokens-component-checkbox-color-unchecked-default-border))",
            "label": "rgb(var(--tokens-component-checkbox-color-unchecked-default-label))"
          },
          "hovered": {
            "border": "rgb(var(--tokens-component-checkbox-color-unchecked-hovered-border))"
          },
          "disabled": {
            "background": "rgb(var(--tokens-component-checkbox-color-unchecked-disabled-background))",
            "border": "rgb(var(--tokens-component-checkbox-color-unchecked-disabled-border))",
            "label": "rgb(var(--tokens-component-checkbox-color-unchecked-disabled-label))"
          },
          "focused": {
            "outline": "rgb(var(--tokens-component-checkbox-color-unchecked-focused-outline))"
          }
        }
      },
      "shape": {
        "border": {
          "radius": {
            "default": "var(--tokens-component-checkbox-shape-border-radius-default)"
          }
        }
      }
    },
    "chipAssistItem": {
      "color": {
        "default": {
          "default": {
            "background": "rgb(var(--tokens-component-chipAssistItem-color-default-default-background))",
            "text": "rgb(var(--tokens-component-chipAssistItem-color-default-default-text))",
            "icon": "rgb(var(--tokens-component-chipAssistItem-color-default-default-icon))",
            "border": "rgb(var(--tokens-component-chipAssistItem-color-default-default-border))"
          },
          "hovered": {
            "background": "rgb(var(--tokens-component-chipAssistItem-color-default-hovered-background))",
            "text": "rgb(var(--tokens-component-chipAssistItem-color-default-hovered-text))",
            "icon": "rgb(var(--tokens-component-chipAssistItem-color-default-hovered-icon))",
            "border": "rgb(var(--tokens-component-chipAssistItem-color-default-hovered-border))"
          }
        },
        "selected": {
          "badge": {
            "background": "rgb(var(--tokens-component-chipAssistItem-color-selected-badge-background))",
            "text": "rgb(var(--tokens-component-chipAssistItem-color-selected-badge-text))",
            "border": "rgb(var(--tokens-component-chipAssistItem-color-selected-badge-border))",
            "hovered": {
              "text": "rgb(var(--tokens-component-chipAssistItem-color-selected-badge-hovered-text))"
            }
          },
          "default": {
            "background": "rgb(var(--tokens-component-chipAssistItem-color-selected-default-background))",
            "text": "rgb(var(--tokens-component-chipAssistItem-color-selected-default-text))",
            "icon": "rgb(var(--tokens-component-chipAssistItem-color-selected-default-icon))",
            "border": "rgb(var(--tokens-component-chipAssistItem-color-selected-default-border))"
          },
          "hovered": {
            "background": "rgb(var(--tokens-component-chipAssistItem-color-selected-hovered-background))",
            "text": "rgb(var(--tokens-component-chipAssistItem-color-selected-hovered-text))",
            "icon": "rgb(var(--tokens-component-chipAssistItem-color-selected-hovered-icon))",
            "border": "rgb(var(--tokens-component-chipAssistItem-color-selected-hovered-border))"
          }
        },
        "special": {
          "badge": {
            "background": "rgb(var(--tokens-component-chipAssistItem-color-special-badge-background))",
            "text": "rgb(var(--tokens-component-chipAssistItem-color-special-badge-text))",
            "border": "rgb(var(--tokens-component-chipAssistItem-color-special-badge-border))",
            "hovered": {
              "text": "rgb(var(--tokens-component-chipAssistItem-color-special-badge-hovered-text))"
            }
          },
          "default": {
            "background": "rgb(var(--tokens-component-chipAssistItem-color-special-default-background))",
            "text": "rgb(var(--tokens-component-chipAssistItem-color-special-default-text))",
            "icon": "rgb(var(--tokens-component-chipAssistItem-color-special-default-icon))",
            "border": "rgb(var(--tokens-component-chipAssistItem-color-special-default-border))"
          },
          "hovered": {
            "background": "rgb(var(--tokens-component-chipAssistItem-color-special-hovered-background))",
            "text": "rgb(var(--tokens-component-chipAssistItem-color-special-hovered-text))",
            "icon": "rgb(var(--tokens-component-chipAssistItem-color-special-hovered-icon))",
            "border": "rgb(var(--tokens-component-chipAssistItem-color-special-hovered-border))"
          }
        },
        "specialSelected": {
          "default": {
            "background": "rgb(var(--tokens-component-chipAssistItem-color-specialSelected-default-background))",
            "text": "rgb(var(--tokens-component-chipAssistItem-color-specialSelected-default-text))",
            "icon": "rgb(var(--tokens-component-chipAssistItem-color-specialSelected-default-icon))",
            "border": "rgb(var(--tokens-component-chipAssistItem-color-specialSelected-default-border))"
          },
          "hovered": {
            "background": "rgb(var(--tokens-component-chipAssistItem-color-specialSelected-hovered-background))",
            "text": "rgb(var(--tokens-component-chipAssistItem-color-specialSelected-hovered-text))",
            "icon": "rgb(var(--tokens-component-chipAssistItem-color-specialSelected-hovered-icon))",
            "border": "rgb(var(--tokens-component-chipAssistItem-color-specialSelected-hovered-border))"
          }
        }
      },
      "shape": {
        "border": {
          "radius": {
            "default": "var(--tokens-component-chipAssistItem-shape-border-radius-default)"
          }
        }
      }
    },
    "chipChoiceItem": {
      "shape": {
        "border": {
          "radius": {
            "default": "var(--tokens-component-chipChoiceItem-shape-border-radius-default)"
          }
        }
      }
    },
    "chipTag": {
      "color": {
        "default": {
          "background": "rgb(var(--tokens-component-chipTag-color-default-background))",
          "border": "rgb(var(--tokens-component-chipTag-color-default-border))",
          "icon": "rgb(var(--tokens-component-chipTag-color-default-icon))",
          "text": "rgb(var(--tokens-component-chipTag-color-default-text))",
          "hovered": {
            "background": "rgb(var(--tokens-component-chipTag-color-default-hovered-background))",
            "text": "rgb(var(--tokens-component-chipTag-color-default-hovered-text))"
          }
        },
        "selected": {
          "background": "rgb(var(--tokens-component-chipTag-color-selected-background))",
          "border": "rgb(var(--tokens-component-chipTag-color-selected-border))",
          "icon": "rgb(var(--tokens-component-chipTag-color-selected-icon))",
          "text": "rgb(var(--tokens-component-chipTag-color-selected-text))",
          "hovered": {
            "background": "rgb(var(--tokens-component-chipTag-color-selected-hovered-background))",
            "icon": "rgb(var(--tokens-component-chipTag-color-selected-hovered-icon))",
            "text": "rgb(var(--tokens-component-chipTag-color-selected-hovered-text))"
          }
        },
        "focused": {
          "outline": "rgb(var(--tokens-component-chipTag-color-focused-outline))"
        }
      },
      "shape": {
        "focused": {
          "border": {
            "radius": "var(--tokens-component-chipTag-shape-focused-border-radius)"
          }
        }
      }
    },
    "dialog": {
      "shape": {
        "border": {
          "radius": {
            "default": "var(--tokens-component-dialog-shape-border-radius-default)"
          }
        }
      }
    },
    "dropdownContent": {
      "shape": {
        "border": {
          "radius": {
            "default": "var(--tokens-component-dropdownContent-shape-border-radius-default)"
          }
        }
      }
    },
    "highlight": {
      "color": {
        "background": {
          "default": "rgb(var(--tokens-component-highlight-color-background-default))"
        },
        "border": {
          "default": "rgb(var(--tokens-component-highlight-color-border-default))"
        }
      },
      "shape": {
        "border": {
          "radius": {
            "default": "var(--tokens-component-highlight-shape-border-radius-default)"
          }
        }
      }
    },
    "image": {
      "shape": {
        "border": {
          "radius": {
            "default": "var(--tokens-component-image-shape-border-radius-default)"
          }
        }
      }
    },
    "input": {
      "shape": {
        "border": {
          "radius": {
            "default": "var(--tokens-component-input-shape-border-radius-default)"
          }
        }
      }
    },
    "link": {
      "color": {
        "default": {
          "text": "rgb(var(--tokens-component-link-color-default-text))",
          "icon": "rgb(var(--tokens-component-link-color-default-icon))",
          "background": {
            "image": "rgb(var(--tokens-component-link-color-default-background-image))"
          },
          "active": {
            "background": {
              "image": "rgb(var(--tokens-component-link-color-default-active-background-image))"
            }
          },
          "caption": {
            "text": "rgb(var(--tokens-component-link-color-default-caption-text))",
            "background": {
              "image": "rgb(var(--tokens-component-link-color-default-caption-background-image))"
            },
            "active": {
              "background": {
                "image": "rgb(var(--tokens-component-link-color-default-caption-active-background-image))"
              }
            }
          }
        },
        "inverse": {
          "text": "rgb(var(--tokens-component-link-color-inverse-text))",
          "icon": "rgb(var(--tokens-component-link-color-inverse-icon))",
          "background": {
            "image": "rgb(var(--tokens-component-link-color-inverse-background-image))"
          },
          "active": {
            "background": {
              "image": "rgb(var(--tokens-component-link-color-inverse-active-background-image))"
            }
          },
          "caption": {
            "text": "rgb(var(--tokens-component-link-color-inverse-caption-text))",
            "background": {
              "image": "rgb(var(--tokens-component-link-color-inverse-caption-background-image))"
            },
            "active": {
              "background": {
                "image": "rgb(var(--tokens-component-link-color-inverse-caption-active-background-image))"
              }
            }
          }
        }
      }
    },
    "multiUpload": {
      "shape": {
        "border": {
          "radius": {
            "default": "var(--tokens-component-multiUpload-shape-border-radius-default)"
          }
        }
      }
    },
    "navItem": {
      "shape": {
        "border": {
          "radius": {
            "default": "var(--tokens-component-navItem-shape-border-radius-default)"
          }
        }
      }
    },
    "progress": {
      "color": {
        "primary": {
          "background": "rgb(var(--tokens-component-progress-color-primary-background))",
          "text": "rgb(var(--tokens-component-progress-color-primary-text))",
          "bar": "rgb(var(--tokens-component-progress-color-primary-bar))"
        },
        "inverse": {
          "background": "rgba(var(--tokens-component-progress-color-inverse-background),var(--tokens-component-progress-color-inverse-background-alpha))",
          "text": "rgb(var(--tokens-component-progress-color-inverse-text))",
          "bar": "rgb(var(--tokens-component-progress-color-inverse-bar))"
        },
        "secondary": {
          "background": "rgb(var(--tokens-component-progress-color-secondary-background))",
          "text": "rgb(var(--tokens-component-progress-color-secondary-text))",
          "bar": "rgb(var(--tokens-component-progress-color-secondary-bar))"
        }
      }
    },
    "radio": {
      "shape": {
        "border": {
          "radius": {
            "default": "var(--tokens-component-radio-shape-border-radius-default)"
          }
        }
      },
      "spacing": {
        "default": {
          "padding": "var(--tokens-component-radio-spacing-default-padding)"
        }
      }
    },
    "searchInput": {
      "shape": {
        "border": {
          "radius": {
            "default": "var(--tokens-component-searchInput-shape-border-radius-default)"
          }
        }
      }
    },
    "select": {
      "color": {
        "option": {
          "default": {
            "text": "rgb(var(--tokens-component-select-color-option-default-text))",
            "background": "rgb(var(--tokens-component-select-color-option-default-background))"
          },
          "disabled": {
            "text": "rgb(var(--tokens-component-select-color-option-disabled-text))",
            "background": "rgb(var(--tokens-component-select-color-option-disabled-background))"
          },
          "placeholder": {
            "default": {
              "text": "rgb(var(--tokens-component-select-color-option-placeholder-default-text))"
            }
          },
          "hovered": {
            "background": "rgb(var(--tokens-component-select-color-option-hovered-background))"
          }
        }
      },
      "typography": {
        "font": {
          "family": "var(--tokens-component-select-typography-font-family)"
        }
      }
    },
    "skeleton": {
      "color": {
        "default": {
          "default": {
            "background": "rgb(var(--tokens-component-skeleton-color-default-default-background))",
            "linearGradient": "linear-gradient(var(--tokens-component-skeleton-color-default-default-linearGradient-alignment), rgba(var(--tokens-component-skeleton-color-default-default-linearGradient-begin-color),var(--tokens-component-skeleton-color-default-default-linearGradient-begin-color-alpha)) var(--tokens-component-skeleton-color-default-default-linearGradient-begin-percentage), rgba(var(--tokens-component-skeleton-color-default-default-linearGradient-medium-color),var(--tokens-component-skeleton-color-default-default-linearGradient-medium-color-alpha)) var(--tokens-component-skeleton-color-default-default-linearGradient-medium-percentage), rgba(var(--tokens-component-skeleton-color-default-default-linearGradient-end-color),var(--tokens-component-skeleton-color-default-default-linearGradient-end-color-alpha)) var(--tokens-component-skeleton-color-default-default-linearGradient-end-percentage))"
          }
        },
        "inverse": {
          "default": {
            "background": "rgba(var(--tokens-component-skeleton-color-inverse-default-background),var(--tokens-component-skeleton-color-inverse-default-background-alpha))",
            "linearGradient": "linear-gradient(var(--tokens-component-skeleton-color-inverse-default-linearGradient-alignment), rgba(var(--tokens-component-skeleton-color-inverse-default-linearGradient-begin-color),var(--tokens-component-skeleton-color-inverse-default-linearGradient-begin-color-alpha)) var(--tokens-component-skeleton-color-inverse-default-linearGradient-begin-percentage), rgba(var(--tokens-component-skeleton-color-inverse-default-linearGradient-medium-color),var(--tokens-component-skeleton-color-inverse-default-linearGradient-medium-color-alpha)) var(--tokens-component-skeleton-color-inverse-default-linearGradient-medium-percentage), rgba(var(--tokens-component-skeleton-color-inverse-default-linearGradient-end-color),var(--tokens-component-skeleton-color-inverse-default-linearGradient-end-color-alpha)) var(--tokens-component-skeleton-color-inverse-default-linearGradient-end-percentage))"
          }
        }
      },
      "shape": {
        "default": {
          "border": {
            "radius": "var(--tokens-component-skeleton-shape-default-border-radius)"
          }
        },
        "circle": {
          "border": {
            "radius": "var(--tokens-component-skeleton-shape-circle-border-radius)"
          }
        }
      },
      "spacing": {
        "default": {
          "margin": {
            "top": "var(--tokens-component-skeleton-spacing-default-margin-top)",
            "left": "var(--tokens-component-skeleton-spacing-default-margin-left)",
            "bottom": "var(--tokens-component-skeleton-spacing-default-margin-bottom)",
            "right": "var(--tokens-component-skeleton-spacing-default-margin-right)"
          }
        }
      }
    },
    "snackbar": {
      "shape": {
        "border": {
          "radius": {
            "default": "var(--tokens-component-snackbar-shape-border-radius-default)"
          }
        }
      }
    },
    "spinner": {
      "color": {
        "default": {
          "indicator": "rgb(var(--tokens-component-spinner-color-default-indicator))",
          "base": "rgba(var(--tokens-component-spinner-color-default-base),var(--tokens-component-spinner-color-default-base-alpha))"
        },
        "critical": {
          "indicator": "rgb(var(--tokens-component-spinner-color-critical-indicator))",
          "base": "rgba(var(--tokens-component-spinner-color-critical-base),var(--tokens-component-spinner-color-critical-base-alpha))"
        },
        "inverse": {
          "indicator": "rgb(var(--tokens-component-spinner-color-inverse-indicator))",
          "base": "rgba(var(--tokens-component-spinner-color-inverse-base),var(--tokens-component-spinner-color-inverse-base-alpha))"
        }
      }
    },
    "statusList": {
      "shape": {
        "border": {
          "radius": {
            "default": "var(--tokens-component-statusList-shape-border-radius-default)"
          }
        }
      }
    },
    "tab": {
      "color": {
        "border": {
          "default": "rgb(var(--tokens-component-tab-color-border-default))"
        }
      }
    },
    "tag": {
      "color": {
        "default": {
          "default": {
            "background": "rgb(var(--tokens-component-tag-color-default-default-background))",
            "icon": "rgb(var(--tokens-component-tag-color-default-default-icon))"
          },
          "disabled": {
            "background": "rgb(var(--tokens-component-tag-color-default-disabled-background))",
            "icon": "rgb(var(--tokens-component-tag-color-default-disabled-icon))"
          }
        },
        "positive": {
          "default": {
            "background": "rgb(var(--tokens-component-tag-color-positive-default-background))",
            "icon": "rgb(var(--tokens-component-tag-color-positive-default-icon))"
          },
          "disabled": {
            "background": "rgb(var(--tokens-component-tag-color-positive-disabled-background))",
            "icon": "rgb(var(--tokens-component-tag-color-positive-disabled-icon))"
          }
        },
        "warning": {
          "default": {
            "background": "rgb(var(--tokens-component-tag-color-warning-default-background))",
            "icon": "rgb(var(--tokens-component-tag-color-warning-default-icon))"
          },
          "disabled": {
            "background": "rgb(var(--tokens-component-tag-color-warning-disabled-background))",
            "icon": "rgb(var(--tokens-component-tag-color-warning-disabled-icon))"
          }
        },
        "special": {
          "default": {
            "background": "rgb(var(--tokens-component-tag-color-special-default-background))",
            "icon": "rgb(var(--tokens-component-tag-color-special-default-icon))",
            "text": "rgb(var(--tokens-component-tag-color-special-default-text))"
          },
          "disabled": {
            "background": "rgb(var(--tokens-component-tag-color-special-disabled-background))",
            "icon": "rgb(var(--tokens-component-tag-color-special-disabled-icon))",
            "text": "rgb(var(--tokens-component-tag-color-special-disabled-text))"
          }
        },
        "critical": {
          "default": {
            "background": "rgb(var(--tokens-component-tag-color-critical-default-background))",
            "icon": "rgb(var(--tokens-component-tag-color-critical-default-icon))"
          },
          "disabled": {
            "background": "rgb(var(--tokens-component-tag-color-critical-disabled-background))",
            "icon": "rgb(var(--tokens-component-tag-color-critical-disabled-icon))"
          }
        },
        "live": {
          "default": {
            "background": "rgb(var(--tokens-component-tag-color-live-default-background))",
            "icon": {
              "transition": {
                "from": "rgb(var(--tokens-component-tag-color-live-default-icon-transition-from))",
                "to": "rgb(var(--tokens-component-tag-color-live-default-icon-transition-to))"
              }
            }
          },
          "disabled": {
            "background": "rgb(var(--tokens-component-tag-color-live-disabled-background))",
            "icon": "rgb(var(--tokens-component-tag-color-live-disabled-icon))"
          }
        }
      },
      "spacing": {
        "icon": {
          "margin": {
            "right": "var(--tokens-component-tag-spacing-icon-margin-right)"
          }
        },
        "padding": {
          "x": "var(--tokens-component-tag-spacing-padding-x)",
          "y": "var(--tokens-component-tag-spacing-padding-y)"
        }
      },
      "shape": {
        "border": {
          "radius": {
            "default": "var(--tokens-component-tag-shape-border-radius-default)"
          }
        }
      }
    },
    "thumbnail": {
      "shape": {
        "border": {
          "radius": {
            "default": "var(--tokens-component-thumbnail-shape-border-radius-default)"
          }
        }
      }
    },
    "tooltip": {
      "color": {
        "background": "rgb(var(--tokens-component-tooltip-color-background))",
        "text": "rgb(var(--tokens-component-tooltip-color-text))",
        "border": "rgb(var(--tokens-component-tooltip-color-border))"
      },
      "spacing": {
        "margin": {
          "default": "var(--tokens-component-tooltip-spacing-margin-default)",
          "arrow": "var(--tokens-component-tooltip-spacing-margin-arrow)"
        }
      },
      "shape": {
        "border": {
          "radius": {
            "default": "var(--tokens-component-tooltip-shape-border-radius-default)"
          }
        }
      }
    }
  },
  "avatar": {
    "color": {
      "inactive": {
        "default": {
          "background": "rgb(var(--tokens-alias-color-surface-highlight-default))",
          "icon": "rgb(var(--tokens-alias-color-icon-brand-default))"
        },
        "success": {
          "background": "rgb(var(--tokens-alias-color-surface-positive-lighter-default))",
          "icon": "rgb(var(--tokens-alias-color-icon-default))"
        },
        "error": {
          "background": "rgb(var(--tokens-alias-color-surface-critical-lighter-default))",
          "icon": "rgb(var(--tokens-alias-color-icon-default))"
        },
        "warning": {
          "background": "rgb(var(--tokens-alias-color-surface-warning-lighter))",
          "icon": "rgb(var(--tokens-alias-color-icon-default))"
        }
      },
      "active": {
        "default": {
          "background": "rgb(var(--tokens-alias-color-surface-brand-highlight))",
          "icon": "rgb(var(--tokens-alias-color-icon-inverse-default))"
        },
        "success": {
          "background": "rgb(var(--tokens-alias-color-surface-positive-default))",
          "icon": "rgb(var(--tokens-alias-color-icon-inverse-default))"
        },
        "error": {
          "background": "rgb(var(--tokens-alias-color-surface-critical-default))",
          "icon": "rgb(var(--tokens-alias-color-icon-inverse-default))"
        },
        "warning": {
          "background": "rgb(var(--tokens-alias-color-surface-warning-default))",
          "icon": "rgb(var(--tokens-alias-color-icon-default))"
        }
      }
    }
  },
  "badge": {
    "shape": {
      "border": {
        "radius": "var(--tokens-alias-shape-border-radius-pill)"
      }
    }
  },
  "button": {
    "color": {
      "default": {
        "default": {
          "background": "rgb(var(--tokens-alias-color-surface-interaction-default))",
          "text": "rgb(var(--tokens-alias-color-text-inverse-default))"
        },
        "hovered": {
          "background": "rgb(var(--tokens-alias-color-surface-interaction-hovered))"
        },
        "active": {
          "background": "rgb(var(--tokens-alias-color-surface-interaction-hovered))"
        },
        "disabled": {
          "text": "rgb(var(--tokens-alias-color-text-onDisabled))",
          "background": "rgb(var(--tokens-alias-color-surface-interaction-disabled))"
        }
      },
      "destructive": {
        "default": {
          "background": "rgb(var(--tokens-alias-color-surface-critical-default))",
          "text": "rgb(var(--tokens-alias-color-text-inverse-default))"
        },
        "hovered": {
          "background": "rgb(var(--tokens-alias-color-surface-critical-hovered))"
        },
        "active": {
          "background": "rgb(var(--tokens-alias-color-surface-critical-hovered))"
        },
        "disabled": {
          "background": "rgb(var(--tokens-alias-color-surface-interaction-disabled))",
          "text": "rgb(var(--tokens-alias-color-text-onDisabled))"
        }
      },
      "defaultInverse": {
        "default": {
          "background": "rgb(var(--tokens-alias-color-surface-default))",
          "text": "rgb(var(--tokens-alias-color-text-default))"
        },
        "hovered": {
          "background": "rgb(var(--tokens-alias-color-surface-hovered))"
        },
        "active": {
          "background": "rgb(var(--tokens-alias-color-surface-hovered))"
        },
        "disabled": {
          "background": "rgba(var(--tokens-alias-color-surface-transparent-default),var(--tokens-alias-color-surface-transparent-default-alpha))",
          "text": "rgba(var(--tokens-alias-color-text-inverse-disabled),var(--tokens-alias-color-text-inverse-disabled-alpha))",
          "border": "rgba(var(--tokens-alias-color-border-inverse-disabled),var(--tokens-alias-color-border-inverse-disabled-alpha))"
        }
      },
      "special": {
        "default": {
          "background": "rgb(var(--tokens-alias-color-surface-interaction-special-default))",
          "text": "rgb(var(--tokens-alias-color-text-inverse-default))"
        },
        "hovered": {
          "background": "rgb(var(--tokens-alias-color-surface-interaction-special-hovered))"
        },
        "active": {
          "background": "rgb(var(--tokens-alias-color-surface-interaction-special-hovered))",
          "border": "rgb(var(--tokens-alias-color-surface-interaction-special-hovered))"
        },
        "disabled": {
          "background": "rgb(var(--tokens-alias-color-surface-interaction-disabled))",
          "text": "rgb(var(--tokens-alias-color-text-onDisabled))"
        }
      },
      "quiet": {
        "default": {
          "background": "rgba(var(--tokens-alias-color-surface-transparent-default),var(--tokens-alias-color-surface-transparent-default-alpha))",
          "text": "rgb(var(--tokens-alias-color-text-interaction-default))",
          "border": "rgb(var(--tokens-alias-color-border-interaction-default))"
        },
        "hovered": {
          "background": "rgb(var(--tokens-alias-color-surface-hovered))",
          "text": "rgb(var(--tokens-alias-color-text-interaction-hovered))",
          "border": "rgb(var(--tokens-alias-color-surface-hovered))"
        },
        "active": {
          "background": "rgb(var(--tokens-alias-color-surface-hovered))",
          "text": "rgb(var(--tokens-alias-color-text-interaction-hovered))",
          "border": "rgb(var(--tokens-alias-color-surface-hovered))"
        },
        "disabled": {
          "text": "rgb(var(--tokens-alias-color-text-disabled))",
          "border": "rgb(var(--tokens-alias-color-border-disabled))"
        }
      },
      "quietDestructive": {
        "default": {
          "background": "rgba(var(--tokens-alias-color-surface-transparent-default),var(--tokens-alias-color-surface-transparent-default-alpha))",
          "text": "rgb(var(--tokens-alias-color-text-critical-default))",
          "border": "rgb(var(--tokens-alias-color-surface-critical-default))"
        },
        "hovered": {
          "background": "rgb(var(--tokens-alias-color-surface-critical-lighter-hovered))",
          "border": "rgb(var(--tokens-alias-color-surface-critical-default))"
        },
        "active": {
          "background": "rgb(var(--tokens-alias-color-surface-critical-lighter-default))",
          "border": "rgb(var(--tokens-alias-color-surface-critical-default))"
        },
        "disabled": {
          "text": "rgb(var(--tokens-alias-color-text-disabled))",
          "border": "rgb(var(--tokens-alias-color-border-disabled))"
        }
      },
      "quietInverse": {
        "default": {
          "background": "rgba(var(--tokens-alias-color-surface-transparent-default),var(--tokens-alias-color-surface-transparent-default-alpha))",
          "text": "rgb(var(--tokens-alias-color-text-inverse-default))",
          "border": "rgb(var(--tokens-alias-color-border-inverse-default))"
        },
        "hovered": {
          "background": "rgba(var(--tokens-alias-color-surface-transparent-hovered),var(--tokens-alias-color-surface-transparent-hovered-alpha))"
        },
        "active": {
          "background": "rgba(var(--tokens-alias-color-surface-transparent-hovered),var(--tokens-alias-color-surface-transparent-hovered-alpha))"
        },
        "disabled": {
          "text": "rgba(var(--tokens-alias-color-text-inverse-disabled),var(--tokens-alias-color-text-inverse-disabled-alpha))"
        }
      },
      "paddingless": {
        "default": {
          "background": "rgba(var(--tokens-alias-color-surface-transparent-default),var(--tokens-alias-color-surface-transparent-default-alpha))",
          "text": "rgb(var(--tokens-alias-color-text-interaction-default))"
        },
        "focused": {
          "text": "rgb(var(--tokens-alias-color-text-interaction-hovered))"
        },
        "active": {
          "text": "rgb(var(--tokens-alias-color-text-interaction-hovered))"
        },
        "disabled": {
          "text": "rgb(var(--tokens-alias-color-text-disabled))"
        }
      },
      "destructivePaddingless": {
        "default": {
          "background": "rgba(var(--tokens-alias-color-surface-transparent-default),var(--tokens-alias-color-surface-transparent-default-alpha))",
          "text": "rgb(var(--tokens-alias-color-text-critical-default))"
        },
        "disabled": {
          "text": "rgb(var(--tokens-alias-color-text-onDisabled))"
        }
      },
      "paddinglessInverse": {
        "default": {
          "background": "rgba(var(--tokens-alias-color-surface-transparent-default),var(--tokens-alias-color-surface-transparent-default-alpha))",
          "text": "rgb(var(--tokens-alias-color-text-inverse-default))"
        },
        "disabled": {
          "text": "rgba(var(--tokens-alias-color-text-inverse-disabled),var(--tokens-alias-color-text-inverse-disabled-alpha))"
        }
      }
    },
    "shape": {
      "default": {
        "border": {
          "radius": "var(--tokens-alias-shape-border-radius-sharp)"
        }
      }
    },
    "spacing": {
      "default": {
        "padding": {
          "x": "var(--tokens-alias-spacing-xsmall)",
          "y": "var(--tokens-alias-spacing-hsmall)"
        }
      },
      "paddingless": {
        "padding": {
          "x": "0",
          "y": "var(--tokens-alias-spacing-hxxsmall)"
        }
      },
      "destructivePaddingless": {
        "padding": {
          "x": "0",
          "y": "var(--tokens-alias-spacing-hxxsmall)"
        }
      },
      "paddinglessInverse": {
        "padding": {
          "x": "0",
          "y": "var(--tokens-alias-spacing-hxxsmall)"
        }
      }
    },
    "font": {
      "icon": {
        "font-size": "16px"
      }
    }
  },
  "chart": {
    "color": {
      "decorative": {
        "01": {
          "default": "#65D2F6"
        },
        "02": {
          "default": "#85D25D"
        },
        "03": {
          "default": "#F19439"
        },
        "04": {
          "default": "#E1667E"
        },
        "05": {
          "default": "#D6C6A2",
          "lighter": "#EDE3CC"
        }
      }
    }
  },
  "checkbox": {
    "color": {
      "checked": {
        "enabled": {
          "background": "rgb(var(--tokens-alias-color-surface-interaction-default))",
          "border": "rgb(var(--tokens-alias-color-border-selected-default))",
          "icon": "rgb(var(--tokens-alias-color-icon-inverse-default))",
          "label": "rgb(var(--tokens-alias-color-text-default))"
        },
        "hovered": {
          "background": "rgb(var(--tokens-alias-color-surface-interaction-hovered))"
        },
        "disabled": {
          "background": "rgb(var(--tokens-alias-color-surface-interaction-disabled))",
          "border": "rgb(var(--tokens-alias-color-surface-interaction-disabled))",
          "icon": "rgb(var(--tokens-alias-color-icon-onDisabled))",
          "label": "rgb(var(--tokens-alias-color-text-disabled))"
        }
      },
      "unchecked": {
        "enabled": {
          "background": "rgb(var(--tokens-alias-color-surface-default))",
          "border": "rgb(var(--tokens-alias-color-border-default))",
          "label": "rgb(var(--tokens-alias-color-text-default))"
        },
        "hovered": {
          "border": "rgb(var(--tokens-alias-color-border-hovered))"
        },
        "disabled": {
          "background": "rgb(var(--tokens-alias-color-surface-default))",
          "border": "rgb(var(--tokens-alias-color-border-disabled))",
          "label": "rgb(var(--tokens-alias-color-text-disabled))"
        },
        "focused": {
          "outline": "rgb(var(--tokens-alias-color-border-focusVisible))"
        }
      }
    },
    "shape": {
      "focused": {
        "border": {
          "radius": "var(--tokens-alias-shape-border-radius-sharp)"
        }
      }
    }
  },
  "chipChoice": {
    "color": {
      "default": {
        "background": "rgb(var(--tokens-alias-color-surface-default))",
        "border": "rgb(var(--tokens-alias-color-border-default))",
        "text": "rgb(var(--tokens-alias-color-text-default))"
      },
      "selected": {
        "background": "rgb(var(--tokens-alias-color-surface-selected-default))",
        "border": "rgb(var(--tokens-alias-color-border-selected-default))",
        "text": "rgb(var(--tokens-alias-color-text-onSelected-default))",
        "hovered": {
          "background": "rgb(var(--tokens-alias-color-surface-selected-default))",
          "border": "rgb(var(--tokens-alias-color-border-selected-hovered))",
          "text": "rgb(var(--tokens-alias-color-text-onSelected-hovered))"
        }
      },
      "disabled": {
        "background": "rgb(var(--tokens-alias-color-surface-interaction-disabled))",
        "text": "rgb(var(--tokens-alias-color-text-onDisabled))"
      },
      "hovered": {
        "background": "rgb(var(--tokens-alias-color-surface-default))",
        "border": "rgb(var(--tokens-alias-color-border-hovered))",
        "text": "rgb(var(--tokens-alias-color-text-default))"
      },
      "focused": {
        "outline": "rgb(var(--tokens-alias-color-border-focusVisible))"
      }
    },
    "shape": {
      "border": {
        "radius": "var(--tokens-alias-shape-border-radius-pill)"
      }
    }
  },
  "chipTag": {
    "color": {
      "default": {
        "background": "rgb(var(--tokens-alias-color-surface-selected-default))",
        "border": "none",
        "icon": "rgb(var(--tokens-alias-color-icon-default))",
        "text": "rgb(var(--tokens-alias-color-text-default))",
        "hovered": {
          "background": "rgb(var(--tokens-alias-color-surface-selected-hovered))"
        }
      },
      "selected": {
        "background": "rgb(var(--tokens-alias-color-surface-selected-default))",
        "border": "rgb(var(--tokens-alias-color-border-selected-default))",
        "hovered": {
          "background": "rgb(var(--tokens-alias-color-surface-selected-hovered))",
          "icon": "rgb(var(--tokens-alias-color-icon-onSelected-hovered))",
          "text": "rgb(var(--tokens-alias-color-text-onSelected-hovered))"
        },
        "icon": "rgb(var(--tokens-alias-color-icon-onSelected-default))",
        "text": "rgb(var(--tokens-alias-color-text-onSelected-default))"
      },
      "focused": {
        "outline": "rgb(var(--tokens-alias-color-border-focusVisible))"
      }
    },
    "shape": {
      "focused": {
        "border": {
          "radius": "var(--tokens-alias-shape-border-radius-medium)"
        }
      }
    }
  },
  "chips": {
    "border": {
      "default": {
        "color": "rgb(var(--tokens-alias-color-border-default))"
      },
      "tagged": {
        "color": "rgb(var(--tokens-alias-color-border-selected-default))"
      }
    },
    "color": {
      "default": {
        "background": "rgb(var(--tokens-alias-color-surface-default))",
        "icon": "rgb(var(--tokens-alias-color-icon-default))",
        "label": "rgb(var(--tokens-alias-color-text-default))"
      },
      "active": {
        "background": "rgb(var(--tokens-alias-color-surface-interaction-special-default))",
        "icon": "rgb(var(--tokens-alias-color-icon-inverse-default))",
        "label": "rgb(var(--tokens-alias-color-text-inverse-default))"
      },
      "tagged": {
        "background": "rgb(var(--tokens-alias-color-surface-selected-default))",
        "icon": "rgb(var(--tokens-alias-color-icon-default))",
        "label": "rgb(var(--tokens-alias-color-text-default))"
      }
    }
  },
  "divider": {
    "color": {
      "default": {
        "border": "rgb(var(--tokens-alias-color-border-default))"
      },
      "light": {
        "border": "rgba(var(--tokens-alias-color-border-inverse-lighter),var(--tokens-alias-color-border-inverse-lighter-alpha))"
      }
    }
  },
  "focusVisible": {
    "shape": {
      "border": {
        "size": "2px",
        "radius": {
          "small": "var(--tokens-alias-shape-border-radius-small)",
          "rounded": "var(--tokens-alias-shape-border-radius-rounded)",
          "sharp": "var(--tokens-alias-shape-border-radius-sharp)"
        },
        "properties": "2px solid rgb(var(--tokens-alias-color-border-focusVisible))"
      }
    },
    "color": {
      "border": "rgb(var(--tokens-alias-color-border-focusVisible))"
    }
  },
  "grid": {
    "breakpoint": {
      "mobile": {
        "minWidth": "0px",
        "maxWidth": "640px",
        "colQuantity": 2,
        "colGutter": 24,
        "marginX": "var(--tokens-alias-spacing-small)"
      },
      "tablet": {
        "minWidth": "641px",
        "maxWidth": "960px",
        "colQuantity": 8,
        "colGutter": 24,
        "marginX": "var(--tokens-alias-spacing-xlarge)"
      },
      "desktop": {
        "minWidth": "961px",
        "maxWidth": "1280px",
        "colQuantity": 12,
        "colGutter": 24,
        "marginX": "var(--tokens-alias-spacing-xlarge)"
      }
    }
  },
  "input": {
    "shape": {
      "default": {
        "border": {
          "radius": "var(--tokens-alias-shape-border-radius-sharp)"
        }
      }
    },
    "spacing": {
      "default": {
        "padding": {
          "x": "var(--tokens-alias-spacing-xsmall)"
        },
        "margin": {
          "y": "var(--tokens-alias-spacing-xxsmall)"
        }
      },
      "multiline": {
        "padding": {
          "top": "var(--tokens-alias-spacing-xxsmall)",
          "x": "var(--tokens-alias-spacing-xsmall)",
          "bottom": "var(--tokens-alias-spacing-medium)"
        }
      }
    },
    "color": {
      "default": {
        "background": "rgb(var(--tokens-alias-color-surface-default))",
        "text": "rgb(var(--tokens-alias-color-text-default))",
        "border": "rgb(var(--tokens-alias-color-border-default))",
        "placeholder": "rgb(var(--tokens-alias-color-text-lighter))"
      },
      "focused": {
        "border": "rgb(var(--tokens-alias-color-border-interaction-default))"
      },
      "disabled": {
        "background": "rgb(var(--tokens-alias-color-surface-interaction-disabled))",
        "text": "rgb(var(--tokens-alias-color-text-onDisabled))",
        "border": "rgb(var(--tokens-alias-color-surface-interaction-disabled))",
        "placeholder": "rgb(var(--tokens-alias-color-text-onDisabled))"
      },
      "error": {
        "background": "rgb(var(--tokens-alias-color-surface-default))",
        "text": "rgb(var(--tokens-alias-color-text-default))",
        "border": "rgb(var(--tokens-alias-color-border-critical))",
        "placeholder": "rgb(var(--tokens-alias-color-text-lighter))"
      },
      "valid": {
        "background": "rgb(var(--tokens-alias-color-surface-default))",
        "text": "rgb(var(--tokens-alias-color-text-default))",
        "border": "rgb(var(--tokens-alias-color-border-positive))",
        "placeholder": "rgb(var(--tokens-alias-color-text-lighter))"
      }
    }
  },
  "link": {
    "color": {
      "default": {
        "text": "rgb(var(--tokens-alias-color-text-interaction-default))",
        "icon": "rgb(var(--tokens-alias-color-icon-interaction-default))",
        "background": {
          "image": "rgb(var(--tokens-alias-color-border-interaction-lighter))"
        },
        "active": {
          "background": {
            "image": "rgb(var(--tokens-alias-color-border-interaction-default))"
          }
        },
        "caption": {
          "text": "rgb(var(--tokens-alias-color-text-lighter))",
          "background": {
            "image": "rgb(var(--tokens-alias-color-border-interaction-lighter))"
          },
          "active": {
            "background": {
              "image": "rgb(var(--tokens-alias-color-border-interaction-default))"
            }
          }
        }
      },
      "inverse": {
        "text": "rgb(var(--tokens-alias-color-text-inverse-default))",
        "icon": "rgb(var(--tokens-alias-color-icon-inverse-default))",
        "background": {
          "image": "rgba(var(--tokens-alias-color-border-inverse-lighter),var(--tokens-alias-color-border-inverse-lighter-alpha))"
        },
        "active": {
          "background": {
            "image": "rgb(var(--tokens-alias-color-border-inverse-default))"
          }
        },
        "caption": {
          "text": "rgba(var(--tokens-alias-color-text-inverse-lighter),var(--tokens-alias-color-text-inverse-lighter-alpha))",
          "background": {
            "image": "rgba(var(--tokens-alias-color-border-inverse-lighter),var(--tokens-alias-color-border-inverse-lighter-alpha))"
          },
          "active": {
            "background": {
              "image": "rgb(var(--tokens-alias-color-border-inverse-default))"
            }
          }
        }
      }
    }
  },
  "progress": {
    "color": {
      "default": {
        "background": "rgb(var(--tokens-alias-color-surface-highlight-default))",
        "text": "rgb(var(--tokens-alias-color-text-lighter))",
        "bar": "rgb(var(--tokens-alias-color-surface-interaction-default))"
      },
      "inverse": {
        "background": "rgba(var(--tokens-alias-color-surface-transparent-disabled),var(--tokens-alias-color-surface-transparent-disabled-alpha))",
        "text": "rgb(var(--tokens-alias-color-text-inverse-default))",
        "bar": "rgb(var(--tokens-alias-color-surface-default))"
      },
      "positive": {
        "background": "rgb(var(--tokens-alias-color-surface-highlight-default))",
        "text": "rgb(var(--tokens-alias-color-text-lighter))",
        "bar": "rgb(var(--tokens-alias-color-surface-brand-highlight))"
      },
      "special": {
        "background": "rgb(var(--tokens-alias-color-surface-highlight-default))",
        "text": "rgb(var(--tokens-alias-color-text-lighter))",
        "bar": "rgb(var(--tokens-alias-color-surface-brand-highlight))"
      }
    }
  },
  "radio": {
    "color": {
      "default": {
        "background": "rgb(var(--tokens-alias-color-surface-default))",
        "border": "rgb(var(--tokens-alias-color-border-default))",
        "icon": "rgb(var(--tokens-alias-color-border-default))",
        "text": "rgb(var(--tokens-alias-color-text-default))",
        "caption": "rgb(var(--tokens-alias-color-text-lighter))"
      },
      "checked": {
        "icon": "rgb(var(--tokens-alias-color-surface-interaction-default))"
      },
      "hovered": {
        "border": "rgb(var(--tokens-alias-color-border-hovered))"
      },
      "disabled": {
        "background": "rgb(var(--tokens-alias-color-surface-interaction-disabled))",
        "border": "rgb(var(--tokens-alias-color-border-disabled))",
        "text": "rgb(var(--tokens-alias-color-text-disabled))"
      }
    },
    "shape": {
      "default": {
        "border": {
          "radius": "var(--tokens-alias-shape-border-radius-rounded)"
        }
      }
    },
    "spacing": {
      "default": {
        "padding": "var(--tokens-alias-spacing-hsmall)"
      }
    }
  },
  "select": {
    "color": {
      "option": {
        "default": {
          "text": "rgb(var(--tokens-alias-color-text-default))",
          "background": "rgb(var(--tokens-alias-color-surface-default))"
        },
        "disabled": {
          "text": "rgb(var(--tokens-alias-color-text-lighter))",
          "background": "rgb(var(--tokens-alias-color-surface-default))"
        },
        "placeholder": {
          "default": {
            "text": "rgb(var(--tokens-alias-color-text-lighter))"
          }
        },
        "hovered": {
          "background": "rgb(var(--tokens-alias-color-surface-hovered))"
        }
      }
    },
    "typography": {
      "font": {
        "family": "var(--tokens-alias-typography-fontFamily)"
      }
    }
  },
  "snackbar": {
    "color": {
      "background": "rgb(var(--tokens-alias-color-surface-highlight-default))",
      "text": "rgb(var(--tokens-alias-color-text-default))",
      "success": {
        "background": "rgb(var(--tokens-alias-color-surface-positive-default))",
        "icon": "rgb(var(--tokens-alias-color-icon-positive))"
      },
      "error": {
        "background": "rgb(var(--tokens-alias-color-surface-critical-default))",
        "icon": "rgb(var(--tokens-alias-color-icon-critical-default))"
      },
      "attention": {
        "background": "rgb(var(--tokens-alias-color-surface-warning-default))",
        "icon": "rgb(var(--tokens-alias-color-icon-warning))"
      }
    },
    "shape": {
      "default": {
        "border": {
          "radius": "var(--tokens-alias-shape-border-radius-sharp)"
        }
      }
    },
    "elevation": {
      "default": {
        "shadow": "\n      var(--tokens-alias-elevation-low-shadow-direct-xOffset) var(--tokens-alias-elevation-low-shadow-direct-yOffset) var(--tokens-alias-elevation-low-shadow-direct-blur) var(--tokens-alias-elevation-low-shadow-direct-spread) rgba(var(--tokens-alias-elevation-low-shadow-direct-color),var(--tokens-alias-elevation-low-shadow-direct-color-alpha)),\n      var(--tokens-alias-elevation-low-shadow-difuse-xOffset) var(--tokens-alias-elevation-low-shadow-difuse-yOffset) var(--tokens-alias-elevation-low-shadow-difuse-blur) var(--tokens-alias-elevation-low-shadow-difuse-spread) rgba(var(--tokens-alias-elevation-low-shadow-difuse-color),var(--tokens-alias-elevation-low-shadow-difuse-color-alpha))\n    "
      }
    }
  },
  "switch": {
    "color": {
      "default": {
        "label": {
          "text": "rgb(var(--tokens-alias-color-text-default))"
        }
      },
      "checked": {
        "background": "rgb(var(--tokens-alias-color-surface-interaction-default))",
        "icon": "rgb(var(--tokens-alias-color-icon-interaction-default))"
      },
      "unchecked": {
        "background": "rgb(var(--tokens-alias-color-surface-interaction-inactive-default))",
        "icon": "rgb(var(--tokens-alias-color-icon-lighter))"
      },
      "hovered": {
        "checked": {
          "icon": "rgb(var(--tokens-alias-color-surface-interaction-hovered))",
          "background": "rgb(var(--tokens-alias-color-surface-interaction-hovered))"
        },
        "unchecked": {
          "background": "rgb(var(--tokens-alias-color-surface-interaction-inactive-hovered))"
        }
      },
      "disabled": {
        "background": "rgb(var(--tokens-alias-color-surface-interaction-disabled))",
        "label": {
          "text": "rgb(var(--tokens-alias-color-text-disabled))"
        },
        "icon": "rgb(var(--tokens-alias-color-icon-disabled))"
      },
      "thumb": {
        "background": "rgb(var(--tokens-alias-color-surface-default))"
      }
    },
    "shape": {
      "track": {
        "border": {
          "radius": "var(--tokens-alias-shape-border-radius-medium)"
        }
      },
      "thumb": {
        "border": {
          "radius": "var(--tokens-alias-shape-border-radius-rounded)"
        }
      }
    },
    "spacing": {
      "default": {
        "margin": {
          "left": "var(--tokens-alias-spacing-xsmall)",
          "right": "var(--tokens-alias-spacing-xsmall)"
        }
      },
      "checked": {
        "transform": {
          "translate": {
            "x": "var(--tokens-alias-spacing-small)"
          }
        }
      },
      "label": {
        "margin": {
          "left": "var(--tokens-alias-spacing-xxsmall)",
          "right": "var(--tokens-alias-spacing-xxsmall)"
        }
      }
    }
  },
  "tag": {
    "color": {
      "default": {
        "default": {
          "background": "rgb(var(--tokens-alias-color-surface-highlight-default))",
          "icon": "rgb(var(--tokens-alias-color-icon-default))"
        },
        "disabled": {
          "background": "rgb(var(--tokens-alias-color-surface-disabled))",
          "icon": "rgb(var(--tokens-alias-color-icon-onDisabled))"
        }
      },
      "positive": {
        "default": {
          "background": "rgb(var(--tokens-alias-color-surface-positive-lighter-default))",
          "icon": "rgb(var(--tokens-alias-color-icon-default))"
        },
        "disabled": {
          "background": "rgb(var(--tokens-alias-color-surface-disabled))",
          "icon": "rgb(var(--tokens-alias-color-icon-onDisabled))"
        }
      },
      "warning": {
        "default": {
          "background": "rgb(var(--tokens-alias-color-surface-warning-lighter))",
          "icon": "rgb(var(--tokens-alias-color-icon-default))"
        },
        "disabled": {
          "background": "rgb(var(--tokens-alias-color-surface-disabled))",
          "icon": "rgb(var(--tokens-alias-color-icon-onDisabled))"
        }
      },
      "special": {
        "default": {
          "background": "rgb(var(--tokens-alias-color-surface-brand-highlight))",
          "icon": "rgb(var(--tokens-alias-color-icon-inverse-default))",
          "text": "rgb(var(--tokens-alias-color-text-inverse-default))"
        },
        "disabled": {
          "background": "rgb(var(--tokens-alias-color-surface-disabled))",
          "icon": "rgb(var(--tokens-alias-color-icon-onDisabled))",
          "text": "rgb(var(--tokens-alias-color-text-disabled))"
        }
      },
      "critical": {
        "default": {
          "background": "rgb(var(--tokens-alias-color-surface-critical-lighter-default))",
          "icon": "rgb(var(--tokens-alias-color-icon-default))"
        },
        "disabled": {
          "background": "rgb(var(--tokens-alias-color-surface-disabled))",
          "icon": "rgb(var(--tokens-alias-color-icon-onDisabled))"
        }
      },
      "live": {
        "default": {
          "background": "rgb(var(--tokens-alias-color-surface-highlight-default))",
          "icon": {
            "transition": {
              "from": "rgb(var(--tokens-alias-color-icon-positive))",
              "to": "rgb(var(--tokens-alias-color-icon-critical-default))"
            }
          }
        },
        "disabled": {
          "background": "rgb(var(--tokens-alias-color-surface-disabled))",
          "icon": "rgb(var(--tokens-alias-color-icon-onDisabled))"
        }
      }
    },
    "spacing": {
      "icon": {
        "margin": {
          "right": "var(--tokens-alias-spacing-hxxsmall)"
        }
      },
      "padding": {
        "x": "3px",
        "y": "var(--tokens-alias-spacing-xxsmall)"
      }
    },
    "shape": {
      "border": {
        "radius": "var(--tokens-alias-shape-border-radius-sharp)"
      }
    }
  },
  "tooltip": {
    "color": {
      "background": "rgb(var(--tokens-alias-color-surface-interaction-default))",
      "text": "rgb(var(--tokens-alias-color-text-inverse-default))",
      "border": "rgb(var(--tokens-alias-color-surface-interaction-default))"
    },
    "shape": {
      "border": {
        "radius": "var(--tokens-alias-shape-border-radius-sharp)"
      }
    },
    "spacing": {
      "margin": {
        "default": "var(--tokens-alias-spacing-hxxsmall)",
        "arrow": "var(--tokens-alias-spacing-hxxsmall)"
      }
    }
  },
  "support": {
    "color": {
      "surface": {
        "brand": {
          "tea": "rgb(var(--tokens-support-color-surface-brand-tea))",
          "cream": "rgb(var(--tokens-support-color-surface-brand-cream))",
          "concrete": "rgb(var(--tokens-support-color-surface-brand-concrete))",
          "warmgray": "rgb(var(--tokens-support-color-surface-brand-warmgray))",
          "black": "rgb(var(--tokens-support-color-surface-brand-black))",
          "wheat": "rgb(var(--tokens-support-color-surface-brand-wheat))",
          "tan": "rgb(var(--tokens-support-color-surface-brand-tan))",
          "coffee": "rgb(var(--tokens-support-color-surface-brand-coffee))",
          "chocolate": "rgb(var(--tokens-support-color-surface-brand-chocolate))",
          "butter": "rgb(var(--tokens-support-color-surface-brand-butter))",
          "ocher": "rgb(var(--tokens-support-color-surface-brand-ocher))",
          "spring": "rgb(var(--tokens-support-color-surface-brand-spring))",
          "lime": "rgb(var(--tokens-support-color-surface-brand-lime))",
          "forest": "rgb(var(--tokens-support-color-surface-brand-forest))",
          "moss": "rgb(var(--tokens-support-color-surface-brand-moss))",
          "frost": "rgb(var(--tokens-support-color-surface-brand-frost))",
          "sky": "rgb(var(--tokens-support-color-surface-brand-sky))",
          "cornflower": "rgb(var(--tokens-support-color-surface-brand-cornflower))",
          "night": "rgb(var(--tokens-support-color-surface-brand-night))",
          "orchid": "rgb(var(--tokens-support-color-surface-brand-orchid))",
          "violet": "rgb(var(--tokens-support-color-surface-brand-violet))",
          "dogwood": "rgb(var(--tokens-support-color-surface-brand-dogwood))",
          "rose": "rgb(var(--tokens-support-color-surface-brand-rose))",
          "blush": "rgb(var(--tokens-support-color-surface-brand-blush))",
          "chery": "rgb(var(--tokens-support-color-surface-brand-chery))",
          "sand": "rgb(var(--tokens-support-color-surface-brand-sand))",
          "brick": "rgb(var(--tokens-support-color-surface-brand-brick))"
        }
      }
    }
  }
};